import React, { createContext, useContext } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, fontStyle, spacing, themeLight } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { propValidationConfig } from './propValidationConfig';

//TextList

const TextListContext = /*#__PURE__*/createContext('bullet');
export const TextList = ({
  children,
  variant = 'bullet',
  className,
  maxWidth
}) => {
  const tag = variant === 'number' ? 'ol' : 'ul';
  return /*#__PURE__*/React.createElement(TextListContext.Provider, {
    value: variant
  }, /*#__PURE__*/React.createElement(List, {
    as: tag,
    className: className,
    maxWidth: maxWidth
  }, children));
};
const renderIcon = variant => {
  switch (variant) {
    case 'close':
      return /*#__PURE__*/React.createElement(CloseIcon, null);
    case 'check':
      return /*#__PURE__*/React.createElement(CheckIcon, null);
    case 'bullet':
    case 'number':
    default:
      return null;
  }
};

// TextListItem

export const TextListItem = ({
  children,
  className
}) => {
  const variant = useContext(TextListContext);
  return /*#__PURE__*/React.createElement(Item, {
    variant: variant,
    className: className
  }, renderIcon(variant), children);
};

// Style
const List = styled.ul.withConfig(propValidationConfig).withConfig({
  displayName: "text-list__List",
  componentId: "sc-rgk3s2-0"
})(["padding:0;margin:0;box-sizing:border-box;padding-left:", ";", ""], spacing.space24, ({
  maxWidth
}) => maxWidth && css(["max-width:", "px;"], maxWidth));
const Item = styled.li.withConfig(propValidationConfig).withConfig({
  displayName: "text-list__Item",
  componentId: "sc-rgk3s2-1"
})(["position:relative;box-sizing:border-box;", ";padding-left:6px;margin-bottom:", ";list-style:none;", " ", " &:last-child,&:only-child{margin-bottom:0;}"], fontStyle.article.articleText, spacing.space8, ({
  variant
}) => variant === 'bullet' && css(["&:before{content:'';width:6px;height:6px;border-radius:50%;background:", ";position:absolute;top:11px;left:calc(-", " - 1px);}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.extras.accent : themeLight.componentColors.extras.accent, spacing.space16), ({
  variant
}) => variant === 'number' && css(["list-style:decimal;"]));
const CheckIcon = () => {
  return /*#__PURE__*/React.createElement(CheckIconWrapper, null, /*#__PURE__*/React.createElement("svg", {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18305 0.307678L9.30679 1.61085L4.07014 7.69229L0.691406 3.78279L1.81515 2.47962L4.07014 5.08596L8.18305 0.307678Z",
    fill: "#062E2A"
  })));
};
const CloseIcon = () => {
  return /*#__PURE__*/React.createElement(CloseIconWrapper, null, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 4.27331L11.7266 3.33331L7.99998 7.05998L4.27331 3.33331L3.33331 4.27331L7.05998 7.99998L3.33331 11.7266L4.27331 12.6666L7.99998 8.93998L11.7266 12.6666L12.6666 11.7266L8.93998 7.99998L12.6666 4.27331Z",
    fill: "#1A1A1A"
  })));
};
const IconWrapper = styled.div.withConfig({
  displayName: "text-list__IconWrapper",
  componentId: "sc-rgk3s2-2"
})(["border-radius:50%;position:absolute;width:", ";height:", ";top:7px;left:calc(-", " - 5px);display:flex;justify-content:center;align-items:center;padding:3px;box-sizing:border-box;svg{width:100%;height:100%;}"], spacing.space16, spacing.space16, spacing.space16);
const CheckIconWrapper = styled(IconWrapper).withConfig({
  displayName: "text-list__CheckIconWrapper",
  componentId: "sc-rgk3s2-3"
})(["background:", ";path{fill:", ";}"], nafColor.primary.park, nafColor.neutral.neutral1);
const CloseIconWrapper = styled(IconWrapper).withConfig({
  displayName: "text-list__CloseIconWrapper",
  componentId: "sc-rgk3s2-4"
})(["background:", ";path{fill:", ";}@media (max-width:", "){background:", ";path{fill:", ";}}"], nafColor.neutral.neutral1, nafColor.signature.black, breakpoints.s, nafColor.signature.white, nafColor.neutral.neutral4);
//# sourceMappingURL=text-list.js.map